<template>
  <div class="license-information">
    <fieldset class="info-group">
      <legend>{{ $t("kyc.licenseInformation") }}</legend>
    </fieldset>
    <fieldset :disabled="kycStatus=== 'submitted'?true:false">
      <div class="info-group">
        <div class="form-group with-icon-right"
            :class="{'has-error': listedCompanyStatus, 'valid': listedCompanyStatus}">
          <div class="input-group">
            <vuestic-kyc-select name="listedCompany"
                                data-vv-as="Listed Company"
                                v-validate="'required'"
                                required
                                :label="$t('kyc.isAListedCompany')"
                                v-model="licenseInformation.listedCompany"
                                option-key="value"
                                :options="licenseOptions"
                                ref="myInput1"
                                @input="forbiddenInput1"
                                :disabled="kycStatus=== 'submitted'?true:false" />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa icon-right input-icon"></i>
            <small v-show="listedCompanyStatus"
                  class="help text-danger">{{ errors.first('listedCompany') }}</small>
          </div>
        </div>
        <div class="info-group-space"></div>
        <div class="form-group with-icon-right"
            :class="{'has-error': aLicenseStatus, 'valid': aLicenseStatus}">
          <div class="input-group">
            <vuestic-kyc-select name="aLicense"
                                data-vv-as="A License"
                                v-validate="'required'"
                                required
                                :label="$t('kyc.heldALicense')"
                                v-model="licenseInformation.aLicense"
                                option-key="value"
                                :options="licenseOptions"
                                ref="myInput2"
                                @input="forbiddenInput2"
                                :disabled="kycStatus=== 'submitted'?true:false" />
            <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
            <i class="fa icon-right input-icon"></i>
            <small v-show="aLicenseStatus"
                  class="help text-danger">{{ errors.first('aLicense') }}</small>
          </div>
        </div>
      </div>
      <div class="info-group" v-if="licenseInformation.aLicense.id === 1">
        <div class="form-group with-icon-right"
            :class="{'has-error': licenseListStatus, 'valid': licenseListStatus}">
          <label for="license"
                class="control-label upload-label app-logo-label-kyc">License：</label>
          <div class="app-logo-wrapper-kyc">
            <!-- :file-types="'.png, .jpg, .jpeg, .gif'" -->
            <vuestic-file-upload-kyc id="license"
                                    type="list"
                                    v-model="licenseInformation.licenseList"
                                    ref="fieldInput"
                                    @input="uploadFile"
                                    @removeFile="removeFile"
                                    :disabled="kycStatus=== 'submitted'?true:false" />
            <small v-show="licenseListStatus"
                    class="help text-danger">{{ $t("kyc.theLicenseFieldIsRequired") }}</small>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
import vuesticFileUploadKyc from '../../../vuestic-theme/vuestic-components/vuestic-file-upload-kyc/VuesticFileUpload'
import mixin from '../mixins/mixin'
export default {
  name: 'license-information',
  mixins: [mixin],
  components: {
    vuesticFileUploadKyc,
  },
  props: {
    kycStatus: {
      type: String,
      default: '',
    },
    merchantData: {
      type: Object,
      default: () => {},
    }
  },
  data () {
    return {
      // 'Yes', 'No'
      licenseOptions: [
        {
          id: 1,
          value: 'Yes'
        }, {
          id: 0,
          value: 'No'
        }
      ],
      listedCompanyStatus: false,
      aLicenseStatus: false,
      licenseListStatus: false,
      licenseInformation: {
        listedCompany: '',
        aLicense: '',
        licenseList: ''
      },
    }
  },
  mounted () {
    this.$refs.myInput1.$el.getElementsByTagName('input')[0].readOnly = true
    this.$refs.myInput1.$el.getElementsByTagName('input')[0].autocomplete =
      'off'
    this.$refs.myInput2.$el.getElementsByTagName('input')[0].readOnly = true
    this.$refs.myInput2.$el.getElementsByTagName('input')[0].autocomplete =
      'off'
    let that = this
    if (that.kycStatus === 'firstEdit') {
      that.getMerchantKYCInfo(2, res => {
        that.setLicenseInfo(res.license_info)
      })
    } else if (that.merchantData.license_info) {
      that.setLicenseInfo(that.merchantData.license_info)
    } else {}
  },
  computed: {},
  methods: {
    setLicenseInfo (info) {
      if (!info) return
      this.licenseInformation.listedCompany = info.is_listed_company === 0 ? {
        id: 0,
        value: 'No'
      } : {
        id: 1,
        value: 'Yes'
      }
      this.licenseInformation.aLicense = info.is_had_license === 0 ? {
        id: 0,
        value: 'No'
      } : {
        id: 1,
        value: 'Yes'
      }
      this.licenseInformation.licenseList = info.license_file_list
    },
    forbiddenInput1 (val) {
      if (!val) {
        this.$refs.myInput1.$el.getElementsByTagName('input')[0].style.height =
          '28px'
        this.listedCompanyStatus = true
      } else {
        this.listedCompanyStatus = false
      }
    },
    forbiddenInput2 (val) {
      if (!val) {
        this.$refs.myInput2.$el.getElementsByTagName('input')[0].style.height =
          '28px'
        this.aLicenseStatus = true
      } else {
        this.aLicenseStatus = false
      }
    },
    checkLicenseInformation () {
      let licenseInformation = ['listedCompany', 'aLicense']
      let isValidate = licenseInformation.reduce((result, current) => {
        if (!this.licenseInformation[current]) {
          this[current + 'Status'] = true
        } else {
          this[current + 'Status'] = false
        }
        return result && !this[current + 'Status']
      }, true)

      if (this.licenseInformation.aLicense === '' || this.licenseInformation.aLicense.id === 0) {
        delete this.licenseInformation.licenseList
        this.licenseListStatus = false
      } else {
        if (!this.licenseInformation.licenseList || this.licenseInformation.licenseList.length === 0) {
          this.licenseListStatus = true
        } else {
          this.licenseListStatus = false
        }
      }
      isValidate = !this.licenseListStatus
      return isValidate
    },
    saveLicenseInfo (cb) {
      let that = this
      this.$validator.validateAll(this.licenseInformation).then((result) => {
        if (that.checkLicenseInformation() && result) {
          let params = {
            page: 2,
            license_info: {
              is_had_license: that.licenseInformation.aLicense.id,
              is_listed_company: that.licenseInformation.listedCompany.id,
            }
          }
          if (that.licenseInformation.aLicense.id === 1) {
            params.license_info.license_file_list = that.licenseInformation.licenseList
          }
          // console.log(params, 'params')
          that.$emit('updateKycInformation', params, function () {
            let flag = true
            cb(flag)
          })
        } else {
          let flag = false
          cb(flag)
        }
      })
    },
    getLicenseInfo (cb) {
      let licenseInfo = new Promise((resolve, reject) => {
        let that = this
        this.$validator.validateAll(this.licenseInformation).then((result) => {
          if (that.checkLicenseInformation() && result) {
            let params = {
              license_info: {
                is_had_license: that.licenseInformation.aLicense.id,
                is_listed_company: that.licenseInformation.listedCompany.id,
              }
            }
            if (that.licenseInformation.aLicense.id === 1) {
              params.license_info.license_file_list = that.licenseInformation.licenseList
            }
            resolve(params)
          } else {
            this.$message({
              type: 'warn',
              message: 'Please fill in License Information'
            })
          }
        })
      })
      return licenseInfo
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid =
          this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    uploadFile (files) {
      if (this.licenseInformation.licenseList.length > 0) {
        this.licenseListStatus = false
      }
    },
    removeFile (file) {
      if (this.licenseInformation.licenseList.length > 0) {
        this.licenseInformation.licenseList = this.licenseInformation.licenseList.filter(image => {
          return file !== image
        })
        if (this.licenseInformation.licenseList.length === 0) {
          this.licenseListStatus = true
        }
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.license-information {
  width: 100%;
  .form-group {
    width: 100%;
  }
  /deep/ .select-form-group {
    margin-bottom: 0;
  }
  /deep/ .vuestic-scrollbar {
    overflow-y: scroll;
  }

  /deep/ .upload-label {
    position: inherit;
  }
  /deep/ .app-logo-label-kyc {
    // width: 105px;
    white-space: nowrap;
    text-overflow: inherit;
    min-width: 10%;
  }
  /deep/ .app-logo-wrapper-kyc {
    white-space: nowrap;
    text-overflow: inherit;
    overflow: inherit;
    width: 90%;
  }
}
</style>
